var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 887,
    height: 718,
    viewBox: "0 0 887 718",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M443 315.338L443 173.032L269.232 1.51912e-05L-3.72845e-05 271.676L443 718L443 575.155L142.661 271.676L269.769 142.845L443 315.338Z",
    fill: "url(#paint0_linear_1277_1580)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M443 315.338L443 173.032L617.16 -1.52255e-05L887 271.676L443 718L443 575.155L744.017 271.676L616.622 142.845L443 315.338Z",
    fill: "url(#paint1_linear_1277_1580)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1277_1580",
    x1: 221.5,
    y1: 0.0000193641,
    x2: 221.5,
    y2: 718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1277_1580",
    x1: 665,
    y1: -0.0000194079,
    x2: 665,
    y2: 718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFade);
export default __webpack_public_path__ + "static/media/heart-fade.bea3b07470f664ab5dc9f9cd780cb1b0.svg";
export { ForwardRef as ReactComponent };